import { Grid, Typography } from '@mui/material';
import moment from 'moment';

import { FormFieldReadOnlyValue } from '../../../../../common';
import { DATE_DISPLAY_FORMAT } from '../../../../../../constants';
import InformationSectionCard from './InformationSectionCard';

import type { InsurancePolicyCardProps } from './types';

export default function InsurancePolicyCard({ title, policy }: InsurancePolicyCardProps) {
  let body;
  if (policy) {
    body = (
      <>
        <FormFieldReadOnlyValue label="Name" value={policy.payor_name ?? ''} />
        <FormFieldReadOnlyValue label="Policy member ID" value={policy.member_id ?? ''} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormFieldReadOnlyValue
              label="Start date"
              value={
                policy.date_start ? moment(policy.date_start).format(DATE_DISPLAY_FORMAT) : ''
              }
            />
          </Grid>
          <Grid item xs={6}>
            <FormFieldReadOnlyValue
              label="End date"
              value={policy.date_end ? moment(policy.date_end).format(DATE_DISPLAY_FORMAT) : ''}
            />
          </Grid>
        </Grid>
      </>
    );
  } else {
    body = (
      <Typography color="text.secondary">
        No {title.toLowerCase()} insurance policy available
      </Typography>
    );
  }

  return <InformationSectionCard title={title}>{body}</InformationSectionCard>;
}
